<template>
	<router-link v-show="Return()" to="/Applet" class="button">
		<input class="btn btn-close" type="button">
	</router-link>
</template>

<script>
	import data from '../data/data.json'
	export default {
		name: "return",
		data() {
			return {
				name: ""
			}
		},
		methods: {
			Return() {
				this.name = this.$route.name
				for (let i of data.app) {
					if (this.name == i) {
						return true;
					}
				}

				return false;
			}
		}
	}
</script>

<style scoped>
	.button {
		position: fixed;
		top: 80px;
		z-index: 1;
		padding: 10px;
		cursor: pointer;
	}
</style>
